export enum CoreConstants {
  SeatNumber = 'seatNumber',
  SelectedTableType = 'selectedTableType',
}

export enum ScreenNameConstants {
  SCREEN_NAME_MIN_LENGTH = '2',
  SCREEN_NAME_MAX_LENGTH = '20',
}

export const GAME_TYPE = {
  // GAME_SHOW
  BINGO: 'BINGO',
  BOOMORBUST: 'BOOMORBUST',
  DICECITY: 'DICECITY',
  MEGASICBAC: 'MEGASICBAC',
  MEGAWHEEL: 'MEGAWHEEL',
  MONEYTIME: 'MONEYTIME',
  SNAKESANDLADDERSLIVE: 'SNAKESANDLADDERSLIVE',
  SWEETBONANZA: 'SWEETBONANZA',
  TREASUREADVENTURE: 'TREASUREADVENTURE',
  TREASUREISLAND: 'TREASUREISLAND',

  // CRASH_GAMES
  BIGBASS: 'BIGBASS',
  HIGHFLYER: 'HIGHFLYER',
  SPACEMAN: 'SPACEMAN',

  //
  AMERICANROULETTE: 'AMERICANROULETTE',
  ANDARBAHAR: 'ANDARBAHAR',
  BACCARAT: 'BACCARAT',
  BLACKJACK: 'BLACKJACK',
  CASINOHOLDEMPOKER: 'CASINOHOLDEMPOKER',
  DRAGONTIGER: 'DRAGONTIGER',
  DRAWPOKER: 'DRAWPOKER',
  ONEBJ: 'ONEBJ',
  POWERBALL: 'POWERBALL',
  ROULETTE: 'ROULETTE',
  SICBO: 'SICBO',
  TOPCARD: 'TOPCARD',
};

export const RESTRICTED_PAGE_URL = '/gsstatic/location-restrictions.html';
export const CRASH_GAMES = [GAME_TYPE.BIGBASS, GAME_TYPE.HIGHFLYER, GAME_TYPE.SPACEMAN];
export const GAME_SHOW_TYPE = [
  GAME_TYPE.BINGO,
  GAME_TYPE.BOOMORBUST,
  GAME_TYPE.DICECITY,
  GAME_TYPE.MEGASICBAC,
  GAME_TYPE.MEGAWHEEL,
  GAME_TYPE.MONEYTIME,
  GAME_TYPE.SNAKESANDLADDERSLIVE,
  GAME_TYPE.SWEETBONANZA,
  GAME_TYPE.TREASUREADVENTURE,
  GAME_TYPE.TREASUREISLAND,
];
